exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-auto{height:200px!important}.img-auto-table{height:100px!important}", ""]);

// exports
